import { useMemo } from 'react';
import { useAwarenessContext } from './useAwarenessContext';
export const useTypingIndicator = (data) => {
    const { conversationAwareness } = useAwarenessContext();
    const indicator = useMemo(() => {
        var _a;
        if (!data)
            return;
        const participants = (_a = conversationAwareness[data.id]) === null || _a === void 0 ? void 0 : _a.participants;
        if (!participants)
            return;
        const names = Object.keys(participants)
            .filter((key) => participants[key].status === 'typing')
            .map((participant) => { var _a; return (_a = data.participants.find(({ id }) => id === participant)) === null || _a === void 0 ? void 0 : _a.name; });
        if (!names.length)
            return;
        return names.length === 1
            ? `${names[0]} is typing`
            : names.length === 2
                ? `${names.join(' and ')} are typing`
                : 'several people are typing';
    }, [data, conversationAwareness]);
    return indicator;
};
//# sourceMappingURL=useTypingIndicator.js.map